import { FormValidations } from "features/shared/forms/hooks/useForm";
import EmailValidationRule from "features/validation/rules/EmailValidationRule";

export const insertAccountValidations = (): FormValidations => {
  return {
    email: {
      required: true,
      type: "Email",
      message: "invalidEmail"
    } as EmailValidationRule
  };
}